import axios from "../api";
export const loginWithEmail = async (email) => {
    const res = await axios.post("/auth/login-with-email", {
        email,
        codeLogin: true,
    });
    return res.data;
};
//# sourceMappingURL=loginWithEmail.js.map